import {SearchItem} from "./search/search-table.dto.res";

export class DocumentCommentDto implements SearchItem {

  public readonly id!: string;
  public approved: Date | undefined;
  public notes: string | undefined;
  public invoiceId: string | undefined;
  public receiptId: string | undefined;

  constructor(init?: Partial<DocumentCommentDto> | undefined) {
    Object.assign(this, init);
    if (init?.approved) {
      this.approved = new Date(init.approved);
    }
  }

  isEditable(): boolean {
    return false;
  }
}
